import { useEffect } from "react";
import { loggerService, type CmsCopy } from "../../infra";
import { useDeveloperToolsStore, useLocaleStore } from "../hooks";
import { useCmsCopyStore } from "../hooks/useCmsCopyStore";
import { useFetchLocaleCopy } from "../hooks/useFetchLocaleCopy";
import { useLocaleCopyStore } from "../hooks/useLocaleCopyStore";

export function LocaleBootstrapper({ slugPrefixes }: Readonly<{ slugPrefixes: string[] }>) {
  const { locale } = useLocaleStore();
  const { useCmsPreview } = useDeveloperToolsStore();

  const { data, isFetching } = useFetchLocaleCopy(slugPrefixes);

  const { setCmsCopy, setIsLoadingCmsCopy } = useCmsCopyStore(state => state.actions);
  const { setLocaleCopy, setIsLoadingLocaleCopy } = useLocaleCopyStore();

  useEffect(() => {
    setIsLoadingLocaleCopy(isFetching);
    setIsLoadingCmsCopy(isFetching);
  }, [isFetching, setIsLoadingLocaleCopy, setIsLoadingCmsCopy]);

  useEffect(() => {
    if (!data) return;

    setCmsCopy(data as CmsCopy);

    loggerService.debug("setting locale data", data);
    if (useCmsPreview) {
      const maybeCopy = (data as unknown as { localeCopy?: Record<string, string> })?.localeCopy;
      if (maybeCopy) setLocaleCopy(maybeCopy as unknown as any); // eslint-disable-line @typescript-eslint/no-explicit-any
    }
  }, [data, setCmsCopy, setLocaleCopy, useCmsPreview, locale]);

  return null;
}
